module.exports = __webpack_public_path__ + "static/media/map-marker.4e5f90d6.png";